import React from 'react'
import Reports from "../../Reports/Reports"

const Reportsdiv = () => {
  return (
    <div>
      <Reports/>
    </div>
  )
}

export default Reportsdiv
